import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { UserRole } from 'src/enums/User';
import { useAuth } from 'src/hooks/useAuth';
import { userRoutes } from 'src/navigators/routes/user';
import { UserToken } from 'src/interfaces';
import { authService } from 'src/services/services/auth/auth.api';
import { ErrorKind, ResponseKind } from 'src/services/services/MainService';
import { parentRoutes } from 'src/navigators/routes/ParentRoutes';
import { useAppDispatch } from 'src/redux/redux-store/hooks';
import { handleUserUpdate } from 'src/redux/redux-store';
import { LoadingOverlay, Text, Stack, Center } from '@mantine/core';

const GoogleOAuth: React.FC = () => {
  // const { login } = useAuth()
  // const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const navigate = useNavigate();
  const { login } = useAuth();
  const dispatch = useAppDispatch();

  // const state = searchParams.get("state");
  console.log("code", code);
  useEffect(() => {
    const sendToken = async () => {
      try {
        const response = await authService.googleTokenSend({ code: code || "" });
        console.log("response", response);

        if (response.kind !== ResponseKind.OK) {
          let errorMessage = "An error occurred during authentication.";

          if (response.kind === ErrorKind.BAD_DATA_ERROR) {
            errorMessage = (response as any).errors ?? "Authentication failed. Please try again.";
          } else if (response.kind === ErrorKind.AUTHORIZATION_ERROR) {
            errorMessage = (response as any).errors ?? "Authentication failed. Please try again.";
          } else if ('errors' in response) {
            errorMessage = response.errors ?? "An error occurred during authentication.";
          }

          alert(errorMessage);
          console.error("Failed to get token:", response);
          navigate("/auth/login", { replace: true });
          return;
        }


        const responseData = response.data;
        const tokenData: UserToken = {
          access_token: responseData?.access_token!,
          refresh_token: responseData?.refresh_token!,
          expires_at: responseData?.expires_at!,
          role: UserRole.parent,
          token_type: "Bearer",
        };

        if (tokenData.role !== UserRole.parent) {
          throw new Error("Login failed: Incorrect user type");
        }

        login(tokenData);
        const user = await dispatch(handleUserUpdate());

        if (!user) {
          throw new Error("Login failed: User not found");
        }

        if (user.walkthrough_completed) {
          navigate("/parent", { replace: true });
        } else {
          navigate(parentRoutes.PREPARE_LEARNERS, { replace: true });
        }

      } catch (error) {
        console.error("Error sending token:", error);
        const errorMessage = error instanceof Error ? error.message : "An unexpected error occurred during authentication.";
        alert(errorMessage);
        navigate("/auth/login", { replace: true });
      }

    };

    sendToken();
  }, []);



  return (
    <div className="flex items-center justify-center min-h-screen bg-white">
      <LoadingOverlay
        visible={true}
        overlayBlur={10}
        loaderProps={{
          children: (
            <Stack align="center" spacing="md">
              <Text size="lg" weight={500}>
                Hold on while we set things up for you...
              </Text>
              <Text size="sm" color="dimmed">
                This will just take a moment
              </Text>
            </Stack>
          ),
        }}
      />
    </div>
  );
};

export default GoogleOAuth;
